import Settings from 'core/Settings';
import EnergyBar from 'core/EnergyBar';
import Maths from 'core/Maths';

class GameState extends Phaser.State {

    create() {
        this.bg1 = this.game.add.tileSprite(0, 0, 800, 400, 'game-background');
        this.bg2 = this.game.add.tileSprite(0, 0, 800, 400, 'game-background-grass');
        this.bg2.alpha = 0;

        this.foreground = this.game.add.tileSprite(0, 0, 800, 76, 'atlas', 'roof');
        this.tweenTint(this.foreground, 0x793B52, 0x793B52, 1000)

        this.game.time.advancedTiming = true;

        this.levelTick = 0;
        this.currentTerrain = 1;

        this.createFastOne();
        this.createPlayer();
        this.createGroups();
        this.createWorld();
        this.enableControls();
        this.createPlatforms();
        this.createProjectiles();
        this.createFurniture();
        this.createReadout();

        this.gameMusic = this.game.sound.play("music", Settings.MUSIC_VOLUME, true);

        this.owState = false;

        this.speed = Settings.SPEED;
        this.startTime = + new Date();
    }

    /**
     * Creates the physics groupings we'll need for terrain and items.
     */
    createGroups() {
        this.platforms = this.game.add.physicsGroup();
        this.furniture = this.game.add.physicsGroup();

        this.projectiles = [];
        this.pickups = [];
        this.enemies = [];
        this.patches = [];
    }

    /**
     * Set up physics.
     */
    createWorld() {
        this.game.physics.startSystem(Phaser.Physics.ARCADE);
        this.game.physics.arcade.gravity.y = Settings.GRAVITY_NORMAL;
    }

    /**
     * Add the player character.
     */
    createPlayer() {
        this.player = this.add.sprite(Settings.PLAYERX, Settings.PLAYERY, "player");
        this.player.scale.set(0.4, 0.4);

        var run = this.player.animations.add('run', [0, 1, 2]);
        var jump = this.player.animations.add('jump', [2], true);
        var ow = this.player.animations.add('ow', [3], true);

        this.player.animations.play('run', 14, true);

        this.player.checkWorldBounds = true;
        this.player.events.onOutOfBounds.add(this.onGameOver, this);
        this.game.physics.enable(this.player, Phaser.Physics.ARCADE);

        this.flashing = false; // flashing state after hitting an enemy
    }

    createFastOne() {
      this.fastone = this.add.sprite(-300, 160, 'fastone');
      var run = this.fastone.animations.add('run', [1, 2, 3]);
      this.fastone.animations.play('run', 8, true);

      this.game.add.tween(this.fastone).to({ y: 170 }, 200, "Expo", true).yoyo(true).repeat(-1);

      this.game.add.tween(this.fastone).to({ x: -100 }, 9000, "Expo", true, 4000).yoyo(true).repeat(-1);
    }

    /**
     * Turn on key/mouse/touch controls.
     */
    enableControls() {
        this.jumping = false;
        this.jumpTimer = 0;

        this.cursors = this.game.input.keyboard.createCursorKeys();
        this.jumpButton = this.game.input.keyboard.addKey(Phaser.Keyboard.SPACEBAR);

        // keyboard actions
        this.jumpButton.onDown.add(this.jump, this);
        this.cursors.up.onDown.add(this.jump, this);
        this.jumpButton.onUp.add(this.unjump, this);
        this.cursors.up.onUp.add(this.unjump, this);

        // mouse/touch actions
        this.game.input.onDown.add(this.jump, this);
        this.game.input.onUp.add(this.unjump, this);
    }

    /**
     * Jump (as long we're on a platform)
     */
    jump() {
        if(this.player.body.velocity.y === 0) {
            this.game.sound.play("jump", Settings.SFX_VOLUME );
            this.player.body.velocity.y = -Settings.JUMPHEIGHT;
        }
    }

    unjump() {
        this.game.physics.arcade.gravity.y = Settings.GRAVITY_HIGH;
    }


    /**
     * Create the platforms.
     */
    createPlatforms() {
        this.offset = 0;

        this.constructLongPlatform(this.offset, 340, 'long-platform1', false);

        // first type
        for(var i = 0; i < 15; i++) {
            this.constructPlatform(this.offset, Maths.randRange(260, 340), this.getPlatform());
        }

        this.constructLongPlatform(this.offset, 340, 'long-platform2', true);

        // second type
        for(var i = 0; i < 15; i++) {
            this.constructPlatform(this.offset, Maths.randRange(260, 340), this.getPlatform2());
        }

        this.overallSpacing = this.offset;
        this.initialOverallSpacing = this.overallSpacing;
    }

    constructPlatform(offsetX, offsetY, type, canHaveItems = true, flipped = false) {
        var platform = this.platforms.create(offsetX, offsetY, 'atlas', type);
        this.game.physics.enable(platform, Phaser.Physics.ARCADE);
        platform.body.allowGravity = false;
        platform.body.immovable = true;
        platform.body.velocity.x = -this.speed;

        this.offset = platform.x + platform.width + 100;

        // spawn either pickups or enemies
        if(canHaveItems) {
            this.diceRoll = Maths.randIntRange(1,10);
            if(this.diceRoll <= 1) {
                // do nothing for now
            }
            else if(this.diceRoll > 1 && this.diceRoll < 7) {
                this.createPickups(platform);
            }
            else {
                this.createEnemies(platform);
            }
        }
    }

    constructLongPlatform(offsetX, offsetY, type, shouldHaveStickyPatch = false) {
      var platform = this.platforms.create(offsetX, offsetY, 'atlas', type);
      this.game.physics.enable(platform, Phaser.Physics.ARCADE);
      platform.body.allowGravity = false;
      platform.body.immovable = true;
      platform.body.velocity.x = -this.speed;

      this.offset = platform.x + platform.width + 100;

      if(shouldHaveStickyPatch) {
        this.createStickyPatch(platform);
      }
    }

    getPlatform() {
        return "platform" + Maths.randIntRange(1,3);
    }

    getPlatform2() {
        return "platform" + Maths.randIntRange(4,6);
    }


    /**
     * Create eye candy elements (forground, particles)
     */
    createFurniture() {
        for(var i = 1; i <= 4; i++) {
            var item = this.furniture.create(Maths.randRange(1000, 8000),  Maths.randRange(0, 200), 'atlas', "foreground" + i);
            item.body.allowGravity = false;
            item.body.immovable = true;
        }

        for(var i = 0; i < 20; i++) {
            var sparkle = this.furniture.create(Maths.randRange(1000, 8000), Maths.randRange(100, 400), 'atlas', "sparkle");
            sparkle.scale.set(Maths.randRange(0, 1));
            sparkle.body.allowGravity = false;
            sparkle.body.immovable = true;
        }
    }


    /**
     * Populate the pickups.
     */
    createPickups(platform) {
        var pickupType;

            for(var i = 0; i < 3; i++) {
                var pickup = platform.addChild(this.game.make.sprite(20 + (i*120), Maths.randRange(-150, -70), 'atlas', this.getPickup()));
                pickup.scale.set(0.7, 0.7);

                pickup.initialScale = {x: pickup.scale.x, y:pickup.scale.y};
                pickup.initialPosition = {x: pickup.x, y: pickup.y};

                this.game.physics.arcade.enable(pickup);
                pickup.body.immovable = true;
                pickup.body.allowGravity = false;

                pickup.checkWorldBounds = true;
                pickup.events.onOutOfBounds.add(this.onPickupOut, this);

                pickup.isPicked = false;

                this.pickups.push(pickup);
            }
    }

    createEnemies(platform) {
        var enemyType;

        platform.enemies = [];

        for(var i = 0; i < 1; i++) {
            var enemy = platform.addChild(this.game.make.sprite(0, 0, 'atlas', this.getEnemy()));
            platform.enemies.push(enemy);
            this.enemies.push(enemy);
            enemy.anchor.set(0.5, 1);
            enemy.x = Maths.randRange(enemy.width, platform.width - enemy.width);
            enemy.y = 7;

            this.refreshEnemy(enemy);
            enemy.body.immovable = true;
            enemy.body.allowGravity = false;
            enemy.checkWorldBounds = true;

            enemy.events.onOutOfBounds.add(this.refreshEnemy, this);
        }
    }

    createStickyPatch(platform) {
        platform.patches = [];

        var patch = platform.addChild(this.game.make.sprite(0, 0, 'sticky'));
        platform.patches.push(patch);
        this.patches.push(patch);
        patch.anchor.set(0.5, 0);
        patch.x = Maths.randRange(patch.width, platform.width - patch.width);
        patch.y = -1;

        this.refreshPatch(patch);

        patch.body.immovable = true;
        patch.body.allowGravity = false;
        patch.checkWorldBounds = true;

        patch.events.onOutOfBounds.add(this.refreshPatch, this);
    }


    refreshEnemy(enemy) {
        enemy.alpha = 1;
        enemy.scale.set(0.6, 0.6);
        this.game.physics.arcade.enable(enemy);
    }

    refreshPatch(patch) {
        patch.alpha = 1;
        patch.scale.set(1, 1);
        this.game.physics.arcade.enable(patch);
    }

    onObjectOut(obj) {
        obj.alpha = 1;
    }

    onPickupOut(obj) {
        obj.scale.set(obj.initialScale.x, obj.initialScale.y);
        obj.x = obj.initialPosition.x;
        obj.y = obj.initialPosition.y;
        obj.alpha = 1;
        obj.isPicked = false;
    }


    getPickup() {
        return 'pickups/pickup' + Maths.randIntRange(1,11);
    }

    getEnemy() {
        return 'monster' + Maths.randIntRange(1,3);
    }


    fruitTweenUpdate(tween) {
        const
            food = tween.target,
            targetX = this.player.x - food.parent.x + 60,
            targetY = this.player.y - food.parent.y + 30;
        food.x += (targetX - food.x) / 7;
        food.y += (targetY - food.y) / 7;
        food.scale.x *= 0.8;
        food.scale.y *= 0.8;
    }

    /**
     * Collect an item, add some health
     */
    onPickup(obj1, obj2) {
        if(!obj2.isPicked) {
            obj2.isPicked = true;
            this.game.add.tween(obj2).to({},  400, "Expo", true)
                .onUpdateCallback(this.fruitTweenUpdate, this)
                .onComplete.add(function () {
                    this.alpha = 0;
                }, obj2);

            this.game.sound.play("pickup", Settings.SFX_VOLUME);

            this.bar.onPickup();
        }
    }


    /**
     * Hit an enemy, start flashing
     */
    onEnemy(obj1, obj2) {

        if(this.flashing) {
            return;
        }

        const duration = 300,
            easing = "Cubic.easeOut";

        let explosion = this.game.make.sprite(obj2.x, obj2.y - obj2.height / 2, 'atlas', 'explosion');
        explosion.anchor.set(0.5);
        explosion.scale.set(0.05);
        explosion.alpha = 0.2;
        obj2.parent.addChild(explosion);

        this.game.add.tween(explosion.scale).to({x: 0.5, y: 0.5}, duration, easing, true).onComplete.add(() => {
            obj2.parent.removeChild(explosion);
        });
        this.game.add.tween(explosion).to({alpha: 0.3, rotation: Math.PI}, duration, easing, true);

        this.game.add.tween(obj2).to({alpha: 0}, duration / 2, easing, true);
        this.game.add.tween(obj2.scale).to({x: 2, y: 2}, duration / 2, easing, true);
        obj2.body = null;

        this.flashing = true;
        this.game.sound.play("ow", Settings.SFX_VOLUME);
        this.bar.onHurt();

        this.startFlashing();
        this.player.animations.play("ow", 15, true);
        this.owState = true;
        this.game.time.events.add(Phaser.Timer.SECOND * 0.3, () => {
            this.owState = false;
        }, this);
    }

    /**
     * Hit an enemy, start flashing
     */
    onPatch(obj1, obj2) {

        if(this.flashing) {
            return;
        }

        this.flashing = true;
        this.game.sound.play("ow", Settings.SFX_VOLUME);
        this.bar.onHurt();

        this.startFlashing();
        this.player.animations.play("ow", 15, true);
        this.owState = true;
        this.game.time.events.add(Phaser.Timer.SECOND * 0.3, () => {
            this.owState = false;
        }, this);
    }

    startFlashing() {
        this.flash = this.game.add.tween(this.player).to({ alpha: 0.2 }, 200, "Expo", true).yoyo(true).repeat(3);
        this.game.time.events.add(Phaser.Timer.SECOND * 2, this.stopFlashing, this);
    }

    stopFlashing() {
        this.flashing = false;
        this.player.alpha = 1;
    }

    createReadout() {
        this.bar = new EnergyBar(this.game);
    }


    /**
     * End the game.
     */
    onGameOver() {
        this.state.start('GameOverState');
    }


    /**
     * GAME LOOP
     */
    update() {
        const elapsedSeconds = (+ new Date() - this.startTime) / 1000;
        this.speed = Math.min(this.speed + elapsedSeconds * Settings.SPEEDUP_PER_SECOND, Settings.MAX_SPEED);
        // scroll background and foreground
        this.bg1.tilePosition.x -= this.speed / 200;
        this.bg2.tilePosition.x -= this.speed / 200;
        this.foreground.tilePosition.x -= (this.speed / 200) * 2.6;

        // scroll furniture
        this.furniture.forEach(function(item) {
            item.x -= (this.speed / 200) * 7;
            if(item.x < -450) {
                item.x += Maths.randRange(4000, 10000);
            }
        }, this);

        // collide player vs terrain
        this.game.physics.arcade.collide(this.player, this.platforms);
        this.player.x = Settings.PLAYERX;

        // collide player vs pickups
        for(var i = 0; i < this.pickups.length; i++) {
            this.game.physics.arcade.overlap(this.player, this.pickups[i], this.onPickup, null, this);
        }

        // collide player vs enemies
        for(var i = 0; i < this.enemies.length; i++) {
            this.game.physics.arcade.overlap(this.player, this.enemies[i], this.onEnemy, null, this);
        }

        // collide player vs patches
        for(var i = 0; i < this.patches.length; i++) {
            this.game.physics.arcade.overlap(this.player, this.patches[i], this.onPatch, null, this);
        }

        // collide player vs projectiles
        for(var i = 0; i < this.projectiles.length; i++) {
            this.game.physics.arcade.collide(this.player, this.projectiles[i], this.onEnemy, null, this);
        }

        this.overallSpacing = this.initialOverallSpacing * Math.pow(this.speed / Settings.SPEED, 2);

        // recycle the platforms
        this.platforms.forEach(function(platform) {
            platform.body.velocity.x = -this.speed;
            if(platform.x <= (0 - platform.width - 100)) {
                platform.x = this.overallSpacing;
                //platform.y = Maths.randRange(260, 340);

                this.organisePlatforms();

                this.checkLevelState();
            }
        }, this);

        // restore gravity if needed
        if(this.player.body.touching.down) {
            this.game.physics.arcade.gravity.y = Settings.GRAVITY_NORMAL;
        }

        if (!this.owState) {
            if(this.player.body.touching.down) {
                this.player.animations.play('run', 14, true);
            }
            else {
                this.player.animations.play('jump');
            }
        }

        // update the bar
        this.bar.update();

        if(Settings.DEBUG)
            this.game.debug.text("FPS: " + this.game.time.fps + " speed: " + this.speed.toFixed(1), 2, 14, "#00ff00");
    }

    /**
     * Jiggle the platform positions so they're measured properly
     */
    organisePlatforms() {
        this.platforms.sort('x', Phaser.Group.SORT_ASCENDING);

        this.offset = 0;

        this.platforms.forEach(function(platform) {
            platform.x = this.offset;
            this.offset += platform.width + 100;
        }, this);
    }

    /**
     * Checks to see if we've progressed far enough to change the terrain.
     */
    checkLevelState() {
        if(this.levelTick < Settings.LEVEL_THRESHOLD) {
            this.levelTick++;
        }
        else {
            this.levelTick = 0;
            this.updateTerrain();
        }

        if(this.projectileTick < Settings.PROJECTILE_THRESHOLD) {
            this.projectileTick++;
        }
        else {
            this.throwProjectile();
        }
    }


    /**
     * Creates the projectile system and warnings.
     */
    createProjectiles() {
        this.warning = this.game.add.sprite(720, Settings.PROJECTILE_MAX, 'warning');
        this.warning.anchor.set(0.5, 0.5);
        this.warning.scale.set(0);

        this.projectileTick = 0;

        // create one of each projectile
        for(var i = 1; i <= 4; i++) {
            var proj = this.game.add.sprite(900, 0, 'atlas', 'projectiles/projectile' + i);
            proj.anchor.set(0, 0.5); // vertically center
            proj.scale.set(1.1);

            this.game.physics.arcade.enable(proj);
            proj.body.immovable = true;
            proj.body.allowGravity = false;

            this.projectiles.push(proj);
        }

        this.flashAnim = this.projectiles[0].addChild(this.game.make.sprite(0, -33, 'atlas', 'projectiles/projectile1anim'));
        this.flash = this.game.add.tween(this.flashAnim).to({alpha:0}, 100, "Expo", true).yoyo(true).repeat(-1);
    }

    throwProjectile() {
        for(var i = 0; i < this.projectiles.length; i++) {
            this.projectiles[i].x = 900;
        }

        // show the warning
        if(Maths.flip())
            this.warning.y = Settings.PROJECTILE_HIGH;
        else
            this.warning.y = Settings.PROJECTILE_LOW;

        this.warnTween = this.game.add.tween(this.warning.scale).to({ x: 1, y:1 }, 500, "Back", true).yoyo(true, 2000)
        this.warning.angle = -5;
        this.warnRotation = this.game.add.tween(this.warning).to({angle:this.warning.angle+10}, 200, "Expo", true).yoyo(true).repeat(6);

        this.game.sound.play("alarm", Settings.SOUND_VOLUME);

        // throw the projectile (with a delay for the warning)
        this.fireProjectileObject();

        // reset and randomise the delay
        this.projectileTick = 0;
        Settings.PROJECTILE_THRESHOLD = Maths.randIntRange(8, 12);
    }

    fireProjectileObject() {
        this.projectile = this.getProjectile();
        this.projectile.y = this.warning.y
        this.throw = this.game.add.tween(this.projectile).to({ x: -400 }, 1000, "Linear", true, 3000);
        this.throw.onStart.add(this.makeWhoosh, this);
    }

    makeWhoosh() {
        this.game.sound.play("whoosh", Settings.SOUND_VOLUME);
    }

    getProjectile() {
        this.selectedProjectile = this.projectiles[Maths.randIntRange(0,3)];
        return this.selectedProjectile;
    }


    /**
     * Changes the terrain visible, and tweens the background.
     * TODO - might need to be smarter if we're adding more terrain types.
     */
    updateTerrain() {
        if(this.currentTerrain == 1) {
            this.currentTerrain = 2;
            this.game.add.tween(this.bg1).to({ alpha: 0 }, Settings.FADE_SPEED, "Linear", true);
            this.game.add.tween(this.bg2).to({ alpha: 1 }, Settings.FADE_SPEED, "Linear", true);

            this.tweenTint(this.foreground, 0x793B52, 0x00FF40, 2000)
        }
        else {
            this.currentTerrain = 1;
            this.game.add.tween(this.bg1).to({ alpha: 1 }, Settings.FADE_SPEED, "Linear", true);
            this.game.add.tween(this.bg2).to({ alpha: 0 }, Settings.FADE_SPEED, "Linear", true);

            this.tweenTint(this.foreground, 0x00FF40, 0x793B52, 2000)
        }
    }

    tweenTint(spriteToTween, startColor, endColor, duration) {

        let colorBlend = {step: 0};

        this.game.add.tween(colorBlend).to({step: 100}, duration, Phaser.Easing.Default, false)
            .onUpdateCallback(() => {
                spriteToTween.tint = Phaser.Color.interpolateColor(startColor, endColor, 100, colorBlend.step, 1);
            })
            .start()

  }

    shutdown() {
        this.gameMusic.stop();
    }
}

export default GameState;
